import { getIn } from 'seamless-immutable';

export const getIsPrime = product => {
  const offers = getIn(product, ['offers', 'result', 0], {});
  const stamps = offers?.stamps?.result;
  return stamps?.includes('PRIME') || false;
};

export const oneDayDeliveryMsg = product => {
  const offers = getIn(product, ['offers', 'result', 0], {});
  const stamps = offers?.stamps?.result;
  const oneDayDelivery = stamps?.filter(stamp => stamp !== 'PRIME' && stamp !== 'INDICA')?.[0];

  return oneDayDelivery ? oneDayDelivery : null;
};
